import { jsx as i } from "react/jsx-runtime";
import { useChatbotContext as s } from "../../hooks/useChatbotContext.js";
function m(t) {
  const { cn: o, promptRef: e, isBuilder: a, isInitializing: r, projectIsHidden: n } = s();
  return /* @__PURE__ */ i(
    "div",
    {
      ...t,
      className: o(
        "custom-scrollbar relative mx-auto flex w-full max-w-[712px] flex-col items-stretch font-sans antialiased transition-colors @container",
        {
          "bg-transparent": a,
          "bg-background text-foreground": !a && !r,
          /**
           * Special handling for hidden projects (standalone, "Live" Chatbots)
           * 130px is the vertical padding of the published interface Page.
           * See packages/service/src/components/Page/Page.tsx in the interfaces repo.
           **/
          "h-[calc(100vh-130px)]": n
        },
        t.className
      ),
      "data-testid": "chatbot-container",
      ref: e
    }
  );
}
export {
  m as Layout
};
